export class BaseRequestModel {
  channelPartnerID?: string;
  apiUser!: string;
  apiPassword!: string;
  serviceID?: string;
  serviceType?: string;
}
